import Location from './Location';

import KaumatuaPorchGraphics from './KaumatuaPorchGraphics';

export default class KaumatuaPorch extends Location {
    constructor() {
        super('kaumatuaPorch');
        this.Graphics = KaumatuaPorchGraphics;
    }

    //Unique guide settings for Wharenui
    guideSettings() {
        return ({
            x: 620,
            y: 300,
            flip: true,
            walk: true,
            id: 'guideProfile',
            //When the guide is ready showSpeech bubble
            callback: this.showSpeech
        });
    }

    maramaSpeaker() {
        return ({
            xmlLoader: this.xmlLoader,
            flip: true,
            x: 362,
            y: 318,
        });
    }

    otherSpeaker() {
        return ({
            xmlLoader: this.xmlLoader,
            x: 173,
            y: 127,
            speaker: this.xmlLoader.getSpeaker()
        });
    }

    //Guide has run out of xml to show
    finishSpeech() {
        //hide the speech bubbles and arm
        super.hideSpeech();
        let nav = this.scene.get('navigate');
        nav.handleLocation({
            location: 'kaumatua'
        });
        this.scene.stop('kaumatuaPorch');

    }



}